export const slugify = str => {
  if (!str) return;
  return str
    .toString()
    .toLowerCase() // Convert to lowercase
    .replace(/^\d+[\s-]*/, '') // Remove leading numbers and optional spaces or hyphens
    .trim() // Remove leading/trailing whitespace
    .replace(/[^a-z0-9\s-]/g, '') // Remove unwanted characters
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Remove consecutive hyphens
    .replace(/^-|-$/g, ''); // Remove leading/trailing hyphens
};
